import React, { ReactNode } from 'react'
import '../../styles/AdvisorCardsModule/AdvisorTagList.scss'

interface AdvisorTagListProps {
  label: string
  children: ReactNode
  variant?: 'certifications'
}

export const AdvisorTagList = ({ label, children, variant }: AdvisorTagListProps) => {
  const className = ['advisor-tag-list', variant && `advisor-tag-list--${variant}`].filter(Boolean).join(' ')
  return (
    <div className={className}>
      <div className='advisor-tag-list__label'>{label}</div>
      <div className='advisor-tag-list__items'>{children}</div>
    </div>
  )
}
